const products = [
  {
    id: 1,
    title: "Mens Casual Premium Slim Fit T-Shirts ",
    price: 520.3,
    description:
      "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
    category: "men clothing",
    image:
      "https://i.ibb.co/vmSrPnm/black-tshirt-main.jpg",
    imageCarousel: [
      {
        image:
          "https://i.ibb.co/vmSrPnm/black-tshirt-main.jpg",
      },
      {
        image:
          "https://i.ibb.co/z5YZD39/mens-casual-tshirt-2.webp",
      },
      {
        image:
          "https://i.ibb.co/Qc5c51y/black-tshirt-back.webp",
      },
    ],
  },
  {
    id: 2,
    title: "Mens Cotton Jacket",
    price: 1550.99,
    description:
      "great outerwear jackets for Spring/Autumn/Winter, suitable for many occasions, such as working, hiking, camping, mountain/rock climbing, cycling, traveling or other outdoors. Good gift choice for you or your family member. A warm hearted love to Father, husband or son in this thanksgiving or Christmas Day.",
    category: "men clothing",
    image: "https://i.ibb.co/Wz7bQGM/blue-jacket.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/Wz7bQGM/blue-jacket.webp",
      },
      {
        image: "https://i.ibb.co/Mn2jfJz/blue-jacket-front-2.jpg",
      },
      {
        image: "https://i.ibb.co/xSSBxsD/blue-jacket-front.webp",
      },
      {
        image: "https://i.ibb.co/tpSqWL0/blue-jacket-back.webp"
      },
      {
        image: "https://i.ibb.co/hgqWwfg/blue-jacket-full.jpg"
      }
    ],
  },
  {
    id: 3,
    title: "Mens Casual Slim Fit",
    price: 550.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men clothing",
    image: "https://i.ibb.co/0V1pZhG/mens-slim-fit.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/0V1pZhG/mens-slim-fit.webp",
      },
      {
        image: "https://i.ibb.co/b2j4BG3/mens-slim-fit-closeup.jpg",
      },
      {
        image: "https://i.ibb.co/BzVb1Bd/mens-slim-fit-back.webp",
      },
      {
        image: "https://i.ibb.co/g6BJ9RK/mens-slim-fit-sideways.webp"
      },
      {
        image: "https://i.ibb.co/g4bjnZD/mens-slim-fit-full.webp"
      }
    ],
  },
  {
    id: 4,
    title:
      "John Hardy Women's Legends Naga Gold & Silver Dragon Station Chain Bracelet",
    price: 695,
    description:
      "From our Legends Collection, the Naga was inspired by the mythical water dragon that protects the ocean's pearl. Wear facing inward to be bestowed with love and abundance, or outward for protection.",
    category: "jewellery",
    image: "https://fakestoreapi.com/img/71pWzhdJNwL._AC_UL640_QL65_ML3_.jpg",
    imageCarousel: [
      {
        image:
          "https://fakestoreapi.com/img/71pWzhdJNwL._AC_UL640_QL65_ML3_.jpg",
      },
      {
        image:
          "https://fakestoreapi.com/img/71pWzhdJNwL._AC_UL640_QL65_ML3_.jpg",
      },
      {
        image:
          "https://fakestoreapi.com/img/71pWzhdJNwL._AC_UL640_QL65_ML3_.jpg",
      },
    ],
  },
  {
    id: 5,
    title: "Solid Gold Petite Micropave ",
    price: 368,
    description:
      "Satisfaction Guaranteed. Return or exchange any order within 30 days.Designed and sold by Hafeez Center in the United States. Satisfaction Guaranteed. Return or exchange any order within 30 days.",
    category: "jewellery",
    image: "https://fakestoreapi.com/img/61sbMiUnoGL._AC_UL640_QL65_ML3_.jpg",
    imageCarousel: [
      {
        image:
          "https://fakestoreapi.com/img/61sbMiUnoGL._AC_UL640_QL65_ML3_.jpg",
      },
      {
        image:
          "https://fakestoreapi.com/img/61sbMiUnoGL._AC_UL640_QL65_ML3_.jpg",
      },
      {
        image:
          "https://fakestoreapi.com/img/61sbMiUnoGL._AC_UL640_QL65_ML3_.jpg",
      },
    ],
  },
  {
    id: 6,
    title: "White Gold Plated Ring",
    price: 9000.99,
    description:
      "Classic Created Wedding Engagement Solitaire Diamond Promise Ring for Her. Gifts to spoil your love more for Engagement, Wedding, Anniversary, Valentine's Day...",
    category: "jewellery",
    image: "https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_.jpg",
    imageCarousel: [
      {
        image:
          "https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_.jpg",
      },
      {
        image:
          "https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_.jpg",
      },
      {
        image:
          "https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_.jpg",
      },
    ],
  },
  {
    id: 7,
    title: "Pierced Owl Rose Gold Plated Stainless Steel Double",
    price: 1000.99,
    description:
      "Rose Gold Plated Double Flared Tunnel Plug Earrings. Made of 316L Stainless Steel",
    category: "jewellery",
    image: "https://fakestoreapi.com/img/51UDEzMJVpL._AC_UL640_QL65_ML3_.jpg",
    imageCarousel: [
      {
        image:
          "https://fakestoreapi.com/img/51UDEzMJVpL._AC_UL640_QL65_ML3_.jpg",
      },
      {
        image:
          "https://fakestoreapi.com/img/51UDEzMJVpL._AC_UL640_QL65_ML3_.jpg",
      },
      {
        image:
          "https://fakestoreapi.com/img/51UDEzMJVpL._AC_UL640_QL65_ML3_.jpg",
      },
    ],
  },
  {
    id: 8,
    title: "WD 2TB Elements Portable External Hard Drive - USB 3.0 ",
    price: 640,
    description:
      "USB 3.0 and USB 2.0 Compatibility Fast data transfers Improve PC Performance High Capacity; Compatibility Formatted NTFS for Windows 10, Windows 8.1, Windows 7; Reformatting may be required for other operating systems; Compatibility may vary depending on user’s hardware configuration and operating system",
    category: "electronics",
    image: "https://fakestoreapi.com/img/61IBBVJvSDL._AC_SY879_.jpg",
    imageCarousel: [
      {
        image: "https://fakestoreapi.com/img/61IBBVJvSDL._AC_SY879_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/61IBBVJvSDL._AC_SY879_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/61IBBVJvSDL._AC_SY879_.jpg",
      },
    ],
  },
  {
    id: 9,
    title: "SanDisk SSD PLUS 1TB Internal SSD SATA III 6 Gb",
    price: 1090,
    description:
      "Easy upgrade for faster boot up, shutdown, application load and response. Boosts burst write performance, making it ideal for typical PC workloads The perfect balance of performance and reliability Read/write speeds of up to 535MB/s/450MB/s",
    category: "electronics",
    image: "https://fakestoreapi.com/img/61U7T1koQqL._AC_SX679_.jpg",
    imageCarousel: [
      {
        image: "https://fakestoreapi.com/img/61U7T1koQqL._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/61U7T1koQqL._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/61U7T1koQqL._AC_SX679_.jpg",
      },
    ],
  },
  {
    id: 10,
    title: "Silicon Power 256GB SSD 3D NAND A55 III 2.5",
    price: 1090,
    description:
      "3D NAND flash are applied to deliver high transfer speeds. The advanced SLC Cache Technology allows performance boost and longer lifespan 7mm slim design suitable for Ultrabooks and Ultra-slim notebooks. Supports TRIM command, Garbage Collection technology, RAID, and ECC to provide the optimized performance and enhanced reliability.",
    category: "electronics",
    image: "https://fakestoreapi.com/img/71kWymZ+c+L._AC_SX679_.jpg",
    imageCarousel: [
      {
        image: "https://fakestoreapi.com/img/71kWymZ+c+L._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/71kWymZ+c+L._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/71kWymZ+c+L._AC_SX679_.jpg",
      },
    ],
  },
  {
    id: 11,
    title:
      "WD 4TB Gaming Drive Works with Playstation 4 Portable External Hard Drive",
    price: 1140,
    description:
      "Expand your PS4 gaming experience, Play anywhere Fast and easy, setup Sleek design with high capacity, 3-year manufacturer's limited warranty",
    category: "electronics",
    image: "https://fakestoreapi.com/img/61mtL65D4cL._AC_SX679_.jpg",
    imageCarousel: [
      {
        image: "https://fakestoreapi.com/img/61mtL65D4cL._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/61mtL65D4cL._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/61mtL65D4cL._AC_SX679_.jpg",
      },
    ],
  },
  {
    id: 12,
    title: "Acer SB220Q bi 21.5 inches Full HD (1920 x 1080) IPS Ultra-Thin",
    price: 5990,
    description:
      "21. 5 inches Full HD (1920 x 1080) widescreen IPS display And Radeon free Sync technology. Refresh Rate: 75Hz - Using HDMI port Zero-frame design | ultra-thin | 4ms response time | IPS panel Aspect ratio - 16: 9. Color Supported - 16. 7 million colors. Brightness - 250 nit Tilt angle -5 degree to 15 degree. Horizontal viewing angle-178 degree. Vertical viewing angle-178 degree 75 hertz",
    category: "electronics",
    image: "https://fakestoreapi.com/img/81QpkIctqPL._AC_SX679_.jpg",
    imageCarousel: [
      {
        image: "https://fakestoreapi.com/img/81QpkIctqPL._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/81QpkIctqPL._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/81QpkIctqPL._AC_SX679_.jpg",
      },
    ],
  },
  {
    id: 13,
    title:
      "Samsung 49-Inch CHG90 144Hz Curved Gaming Monitor (LC49HG90DMNXZA) – Super Ultrawide Screen QLED ",
    price: 999.99,
    description:
      "49 INCH SUPER ULTRAWIDE 32:9 CURVED GAMING MONITOR with dual 27 inch screen side by side QUANTUM DOT (QLED) TECHNOLOGY, HDR support and factory calibration provides stunningly realistic and accurate color and contrast 144HZ HIGH REFRESH RATE and 1ms ultra fast response time work to eliminate motion blur, ghosting, and reduce input lag",
    category: "electronics",
    image: "https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_.jpg",
    imageCarousel: [
      {
        image: "https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_.jpg",
      },
      {
        image: "https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_.jpg",
      },
    ],
  },
  {
    id: 14,
    title: "BIYLACLESEN Women's 3-in-1 Snowboard Jacket Winter Coats",
    price: 1060.99,
    description:
      "Note:The Jackets is US standard size, Please choose size as your usual wear Material: 100% Polyester; Detachable Liner Fabric: Warm Fleece.Zippered Pockets: 2 Zippered Hand Pockets, 2 Zippered Pockets on Chest and 1 Hidden Pocket Inside.Zippered Hand Pockets and Hidden Pocket keep your things secure",
    category: "women clothing",
    image: "https://i.ibb.co/dQPkvMW/women-brown-winter-jacket-3.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/dQPkvMW/women-brown-winter-jacket-3.webp",
      },
      {
        image: "https://i.ibb.co/7pYNZfk/women-brown-winter-jacket-1.webp",
      },
      {
        image: "https://i.ibb.co/KWjnSgt/women-brown-winter-jacket-2.webp",
      },
    ],
  },
  {
    id: 15,
    title:
      "Lock and Love Women's Removable Hooded Faux Leather Moto Biker Jacket",
    price: 1290.95,
    description:
      "100% POLYURETHANE(shell) 100% POLYESTER(lining) 75% POLYESTER 25% COTTON (SWEATER), Faux leather material for style and comfort / 2 pockets of front, 2-For-One Hooded denim style faux leather jacket, Button detail on waist / Detail stitching at sides, HAND WASH ONLY / DO NOT BLEACH / LINE DRY / DO NOT IRON",
    category: "women clothing",
    image: "https://i.ibb.co/YXkk2Y1/women-denim-1.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/YXkk2Y1/women-denim-1.jpg",
      },
      {
        image: "https://i.ibb.co/qy9jHMd/women-denim-3.jpg",
      },
      {
        image: "https://i.ibb.co/FKC5nHs/women-denim-2.jpg",
      },
    ],
  },
  {
    id: 16,
    title: "Fancy Women Jacket",
    price: 1390.99,
    description:
      "Lightweight perfet for trip or casual wear- Long sleeve with hooded, adjustable drawstring waist design. Button and zipper front closure raincoat, fully stripes Lined and The Raincoat has 2 side pockets and the hood is generous but doesn't overdo it.Attached Cotton Lined Hood with Adjustable Drawstrings.",
    category: "women clothing",
    image: "https://i.ibb.co/DtjLJkP/women-fancy-1.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/DtjLJkP/women-fancy-1.jpg",
      },
      {
        image: "https://i.ibb.co/fnXgv3b/women-fancy-3.jpg",
      },
      {
        image: "https://i.ibb.co/tbDsbLR/women-fancy-2.jpg",
      },
    ],
  },
  {
    id: 17,
    title: "Grey Winter Jacket",
    price: 500.85,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "women clothing",
    image: "https://i.ibb.co/TB9FCzp/women-coat-3.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/TB9FCzp/women-coat-3.jpg",
      },
      {
        image: "https://i.ibb.co/mRFMWhH/women-coat-1.webp",
      },
      {
        image: "https://i.ibb.co/RDLgknc/women-coat-2.jpg",
      },
    ],
  },
  {
    id: 18,
    title: "Blue Printed Casual T-Shirt Top",
    price: 700.95,
    description:
      "100% Polyester, Machine wash, 100% cationic polyester interlock, Machine Wash & Pre Shrunk for a Great Fit, Lightweight, roomy and highly breathable with moisture wicking fabric which helps to keep moisture away, Soft Lightweight Fabric with comfortable V-neck collar and a slimmer fit, delivers a sleek, more feminine silhouette and Added Comfort",
    category: "women clothing",
    image: "https://i.ibb.co/LJ1r0vg/women-blue-casual-t1.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/LJ1r0vg/women-blue-casual-t1.jpg",
      },
      {
        image: "https://i.ibb.co/Jx9YPz8/women-blue-casual-t3.jpg",
      },
      {
        image: "https://i.ibb.co/nLCD8sD/women-blue-casual-t2.jp",
      },
    ],
  },
  {
    id: 19,
    title: "DANVOUY Womens Casual Cotton T-Shirt",
    price: 2420.99,
    description:
      "95%Cotton,5%Spandex, Features: Casual, Short Sleeve, Letter Print,V-Neck,Fashion Tees, The fabric is soft and has some stretch., Occasion: Casual/Office/Beach/School/Home/Street. Season: Spring,Summer,Autumn,Winter.",
    category: "women clothing",
    image: "https://i.ibb.co/0DX8z6L/women-yellow-tshirt-1.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/0DX8z6L/women-yellow-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/jHrmxTf/women-yellow-tshirt-3.webp",
      },
      {
        image: "https://i.ibb.co/WF4SrjS/women-yellow-tshirt-2.webp",
      },
    ],
  },
  {
    id: 20,
    title: "Men's Black T Shirt Casual Cotton",
    price: 520.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "tshirt",
    image: "https://i.ibb.co/PtV8zXF/black-tshirt.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/PtV8zXF/black-tshirt.jpg",
      },
      {
        image: "https://i.ibb.co/PtV8zXF/black-tshirt.jpg",
      },
      {
        image: "https://i.ibb.co/PtV8zXF/black-tshirt.jpg",
      },
    ],
  },
  {
    id: 21,
    title: "Men's Black T Shirt Casual Cotton",
    price: 520.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men clothing",
    image: "https://i.ibb.co/PtV8zXF/black-tshirt.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/PtV8zXF/black-tshirt.jpg",
      },
      {
        image: "https://i.ibb.co/PtV8zXF/black-tshirt.jpg",
      },
      {
        image: "https://i.ibb.co/PtV8zXF/black-tshirt.jpg",
      },
    ],
  },
  {
    id: 22,
    title: "Men's Yellow T Shirt Pattern",
    price: 1190.96,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "tshirt",
    image: "https://i.ibb.co/3s3TFTW/yellow-tshirt-front.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/3s3TFTW/yellow-tshirt-front.webp",
      },
      {
        image: "https://i.ibb.co/0mgTnfr/yellow-tshirt-full.webp",
      },
      {
        image: "https://i.ibb.co/HNJx6wb/yellow-tshirt-sideways.webp",
      },
      {
        image: "https://i.ibb.co/pX3sGYc/yellow-tshirt-back.webp"
      },
      {
        image: "https://i.ibb.co/Mg7LVJV/yellow-tshirt-zoomed.jpg"
      }
    ],
  },
  {
    id: 23,
    title: "Men's Yellow T Shirt Pattern",
    price: 1190.96,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men clothing",
    image: "https://i.ibb.co/3s3TFTW/yellow-tshirt-front.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/3s3TFTW/yellow-tshirt-front.webp",
      },
      {
        image: "https://i.ibb.co/0mgTnfr/yellow-tshirt-full.webp",
      },
      {
        image: "https://i.ibb.co/HNJx6wb/yellow-tshirt-sideways.webp",
      },
      {
        image: "https://i.ibb.co/pX3sGYc/yellow-tshirt-back.webp"
      },
      {
        image: "https://i.ibb.co/Mg7LVJV/yellow-tshirt-zoomed.jpg"
      }
    ],
  },
  {
    id: 24,
    title: "Men's White T Shirt Printed",
    price: 620.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "tshirt",
    image: "https://i.ibb.co/CBgF3km/white-tshirt-front.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/CBgF3km/white-tshirt-front.jpg",
      },
      {
        image: "https://i.ibb.co/CBgF3km/white-tshirt-front.jpg",
      },
      {
        image: "https://i.ibb.co/CBgF3km/white-tshirt-front.jpg",
      },
    ],
  },
  {
    id: 25,
    title: "Men's White T Shirt Printed",
    price: 420.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men clothing",
    image: "https://i.ibb.co/CBgF3km/white-tshirt-front.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/CBgF3km/white-tshirt-front.jpg",
      },
      {
        image: "https://i.ibb.co/CBgF3km/white-tshirt-front.jpg",
      },
      {
        image: "https://i.ibb.co/CBgF3km/white-tshirt-front.jpg",
      },
    ],
  },
  {
    id: 26,
    title: "Mens Casual Premium Slim Fit T-Shirts ",
    price: 520.3,
    description:
      "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
    category: "tshirt",
    image:
      "https://i.ibb.co/vmSrPnm/black-tshirt-main.jpg",
    imageCarousel: [
      {
        image:
          "https://i.ibb.co/vmSrPnm/black-tshirt-main.jpg",
      },
      {
        image:
          "https://i.ibb.co/z5YZD39/mens-casual-tshirt-2.webp",
      },
      {
        image:
          "https://i.ibb.co/Qc5c51y/black-tshirt-back.webp",
      },
    ],
  },
  {
    id: 27,
    title: "Mens Casual Slim Fit",
    price: 1620.88,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "tshirt",
    image: "https://i.ibb.co/0V1pZhG/mens-slim-fit.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/0V1pZhG/mens-slim-fit.webp",
      },
      {
        image: "https://i.ibb.co/b2j4BG3/mens-slim-fit-closeup.jpg",
      },
      {
        image: "https://i.ibb.co/BzVb1Bd/mens-slim-fit-back.webp",
      },
      {
        image: "https://i.ibb.co/g6BJ9RK/mens-slim-fit-sideways.webp"
      },
      {
        image: "https://i.ibb.co/g4bjnZD/mens-slim-fit-full.webp"
      }
    ],
  },
  {
    id: 28,
    title: "Womens Black Casual Slim Fit",
    price: 1450.99,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "women clothing",
    image: "https://i.ibb.co/3hNf3vd/women-black-tshirt-1.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/3hNf3vd/women-black-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/VCS6q6s/women-black-tshirt-2.jpg",
      },
      {
        image: "https://i.ibb.co/Jnqb6FW/women-black-tshirt-3.jpg",
      },
    ],
  },
  {
    id: 29,
    title: "Womens Black Casual Slim Fit",
    price: 1450.99,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "tshirt",
    image: "https://i.ibb.co/3hNf3vd/women-black-tshirt-1.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/3hNf3vd/women-black-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/VCS6q6s/women-black-tshirt-2.jpg",
      },
      {
        image: "https://i.ibb.co/Jnqb6FW/women-black-tshirt-3.jpg",
      },
    ],
  },
  {
    id: 30,
    title: "Womens Pink Casual T Shirt",
    price: 660.7,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "tshirt",
    image: "https://i.ibb.co/Ypht3jv/women-dusty-pink-tshirt-1.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/Ypht3jv/women-dusty-pink-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/G7qJFyB/women-dusty-pink-tshirt-3.jpg",
      },
      {
        image: "https://i.ibb.co/6R7HTKL/women-dusty-pink-tshirt-2.jpg",
      },
    ],
  },
  {
    id: 31,
    title: "Womens Pink Casual T Shirt",
    price: 460.7,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "women clothing",
    image: "https://i.ibb.co/Ypht3jv/women-dusty-pink-tshirt-1.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/Ypht3jv/women-dusty-pink-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/G7qJFyB/women-dusty-pink-tshirt-3.jpg",
      },
      {
        image: "https://i.ibb.co/6R7HTKL/women-dusty-pink-tshirt-2.jpg",
      },
    ],
  },
  {
    id: 32,
    title: "Womens Casual Slim Fit",
    price: 530.68,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "tshirt",
    image: "https://i.ibb.co/fxd5yvM/women-pink-tshirt-1.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/fxd5yvM/women-pink-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/8s2PN6F/women-pink-tshirt-3.webp",
      },
      {
        image: "https://i.ibb.co/fv7jhfH/women-pink-tshirt-2.jpg",
      },
    ],
  },
  {
    id: 33,
    title: "Womens Casual Slim Fit",
    price: 430.68,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "women clothing",
    image: "https://i.ibb.co/fxd5yvM/women-pink-tshirt-1.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/fxd5yvM/women-pink-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/8s2PN6F/women-pink-tshirt-3.webp",
      },
      {
        image: "https://i.ibb.co/fv7jhfH/women-pink-tshirt-2.jpg",
      },
    ],
  },
  {
    id: 34,
    title: "Womens White Casual T Shirt",
    price: 3240.68,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "tshirt",
    image: "https://i.ibb.co/wLFMtbG/women-white-tshirt-2.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/wLFMtbG/women-white-tshirt-2.webp",
      },
      {
        image: "https://i.ibb.co/bW0S4pR/women-white-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/yVZ8RnD/women-white-tshirt-3.jpg",
      },
    ],
  },
  {
    id: 35,
    title: "Womens White Casual T Shirt",
    price: 3240.68,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "women clothing",
    image: "https://i.ibb.co/wLFMtbG/women-white-tshirt-2.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/wLFMtbG/women-white-tshirt-2.webp",
      },
      {
        image: "https://i.ibb.co/bW0S4pR/women-white-tshirt-1.webp",
      },
      {
        image: "https://i.ibb.co/yVZ8RnD/women-white-tshirt-3.jpg",
      },
    ],
  },
  {
    id: 36,
    title: "Mens Cotton Jacket",
    price: 750.99,
    description:
      "great outerwear jackets for Spring/Autumn/Winter, suitable for many occasions, such as working, hiking, camping, mountain/rock climbing, cycling, traveling or other outdoors. Good gift choice for you or your family member. A warm hearted love to Father, husband or son in this thanksgiving or Christmas Day.",
    category: "jacket",
    image: "https://i.ibb.co/Wz7bQGM/blue-jacket.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/Wz7bQGM/blue-jacket.webp",
      },
      {
        image: "https://i.ibb.co/Mn2jfJz/blue-jacket-front-2.jpg",
      },
      {
        image: "https://i.ibb.co/xSSBxsD/blue-jacket-front.webp",
      },
      {
        image: "https://i.ibb.co/tpSqWL0/blue-jacket-back.webp"
      },
      {
        image: "https://i.ibb.co/hgqWwfg/blue-jacket-full.jpg"
      }
    ]
  },
  {
    id: 37,
    title:
      "Lock and Love Women's Removable Hooded Faux Leather Moto Biker Jacket",
    price: 1290.95,
    description:
      "100% POLYURETHANE(shell) 100% POLYESTER(lining) 75% POLYESTER 25% COTTON (SWEATER), Faux leather material for style and comfort / 2 pockets of front, 2-For-One Hooded denim style faux leather jacket, Button detail on waist / Detail stitching at sides, HAND WASH ONLY / DO NOT BLEACH / LINE DRY / DO NOT IRON",
    category: "jacket",
    image: "https://i.ibb.co/YXkk2Y1/women-denim-1.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/YXkk2Y1/women-denim-1.jpg",
      },
      {
        image: "https://i.ibb.co/qy9jHMd/women-denim-3.jpg",
      },
      {
        image: "https://i.ibb.co/FKC5nHs/women-denim-2.jpg",
      },
    ],
  },
  {
    id: 38,
    title: "BIYLACLESEN Women's 3-in-1 Snowboard Jacket Winter Coats",
    price: 1060.99,
    description:
      "Note:The Jackets is US standard size, Please choose size as your usual wear Material: 100% Polyester; Detachable Liner Fabric: Warm Fleece. Zippered Pockets: 2 Zippered Hand Pockets, 2 Zippered Pockets on Chest and 1 Hidden Pocket Inside.Zippered Hand Pockets and Hidden Pocket keep your things secure.",
    category: "jacket",
    image: "https://i.ibb.co/dQPkvMW/women-brown-winter-jacket-3.webp",
    imageCarousel: [
      {
        image: "https://i.ibb.co/dQPkvMW/women-brown-winter-jacket-3.webp",
      },
      {
        image: "https://i.ibb.co/7pYNZfk/women-brown-winter-jacket-1.webp",
      },
      {
        image: "https://i.ibb.co/KWjnSgt/women-brown-winter-jacket-2.webp",
      },
    ],
  },
  {
    id: 39,
    title: "Fancy Women Jacket",
    price: 1390.99,
    description:
      "Lightweight perfet for trip or casual wear Long sleeve with hooded, adjustable drawstring waist design. Button and zipper front closure raincoat, fully stripes Lined and The Raincoat has 2 side pockets and the hood is generous but doesn't overdo it.Attached Cotton Lined Hood with Adjustable Drawstrings.",
    category: "jacket",
    image: "https://i.ibb.co/DtjLJkP/women-fancy-1.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/DtjLJkP/women-fancy-1.jpg",
      },
      {
        image: "https://i.ibb.co/fnXgv3b/women-fancy-3.jpg",
      },
      {
        image: "https://i.ibb.co/tbDsbLR/women-fancy-2.jpg",
      },
    ],
  },
  {
    id: 40,
    title: "Men's Blue Gradient Shirt ",
    price: 809.95,
    description: "Men's Lenin shirt three quarter sleeve gradient blue",
    category: "men clothing",
    image: "https://i.ibb.co/1GjWHnF/blue-shirt.jpg",
    imageCarousel: [
      {
        image: "https://i.ibb.co/1GjWHnF/blue-shirt.jpg",
      },
      {
        image: "https://i.ibb.co/1GjWHnF/blue-shirt.jpg",
      },
      {
        image: "https://i.ibb.co/1GjWHnF/blue-shirt.jpg",
      },
    ],
  },
];

export default products;
